import MessagesContext from '@/shared/lib/context/patientMessageContext';
import { useContext } from 'react';

const useMessages = () => {
  const context = useContext(MessagesContext);

  if (!context) {
    throw new Error('useMessages must be used within a MessagesProvider');
  }

  return context;
};

export default useMessages;
